(function ($) {
  Drupal.behaviors.faqV1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $template = $('.js-faq-v1', context);
      var $trigger = $('.js-faq__headline', $template);

      // Check if this has a trigger
      if ($trigger.length) {
        // Toggle the nav
        $trigger.once().on('click', function () {
          var $this = $(this);
          var $parent = $this.parent();
          var $content = $this.next('.js-faq__content');
          // Cast the expanded state as a boolean
          var expanded = $parent.attr('aria-expanded') === 'false' ? false : true;

          // Switch the states of aria-expanded and aria-hidden
          $parent.attr('aria-expanded', !expanded);
          $content.attr('aria-hidden', expanded);
        });
      }
    }
  };
})(jQuery);
